module.exports = __webpack_public_path__ + "img/icon1.6a20aa97.png";